import {useEffect, useState} from 'react'

export function useOnScreen(ref, className) {

    const [isIntersecting, setIntersecting] = useState(false)
    const [fadeClass, setFadeClass] = useState(null)
  
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting)
    )
  
    useEffect(() => {
      observer.observe(ref.current)
      // Remove the observer as soon as the component is unmounted
      return () => { observer.disconnect() }
    }, [])

    useEffect(() => {
        if(isIntersecting && !fadeClass) setFadeClass(className)
    }, [isIntersecting])
  
    return fadeClass
  }